import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required — icon-only buttons must be labelled for screen readers. */
  'aria-label': string;
  icon: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'ghost' | 'danger';
  round?: boolean;
}

/** Square (or round) icon-only button with a mandatory aria-label. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, size = 'md', variant = 'default', round = false, className, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx(
        'tc-icon-btn',
        size !== 'md' && `tc-icon-btn--${size}`,
        variant !== 'default' && `tc-icon-btn--${variant}`,
        round && 'tc-icon-btn--round',
        className,
      )}
      {...rest}
    >
      {icon}
    </button>
  );
});
